// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.gui_page-wrapper_XhImG {
    height: 100%;
}

.gui_body-wrapper_G5GJN {
    height: calc(100% - 3rem);
    background-color: var(--ui-primary);
}

.gui_body-wrapper_G5GJN * {
    box-sizing: border-box;
}

.gui_flex-wrapper_zZPgR {
    display: flex;

    /*
        Make 2 columns:
        a) for the blocks + workspace panes, and
        b) for combined stage menu + stage + sprite/stage selectors
    */
    flex-direction: row;
    height: 100%;

    /*
        Stop scrollbar popping in and out from scratch-blocks border issue
        https://github.com/LLK/scratch-gui/issues/318
        TW: and also fix double horizontal scrollbar at some screen sizes in paint editor
    */
    overflow: hidden;
}

.gui_editor-wrapper_w4WEQ {
    /*
        This is carefully balanced--  the minimum width at which the GUI will be displayed is 1024px.
        At that size, the stage pane is 408px wide, with \$space of padding to each side.
        However, we must also add the border width to the stage pane. All-in-all, the stage pane's final width is
        408px + (\$space + \$stage-standard-border-width * 2) (one border & padding per left/right side).

        @todo This is in place to prevent "doubling up" of horizontal scrollbars in narrow windows, but there are likely
        much better ways to solve that (e.g. undo #2124, remove this flex-basis entirely). However, they run their own
        risks of breaking things, so let's just leave this as-is for the time being.
    */
    flex-basis: calc(1024px - 408px - ((0.5rem + 0.0625rem) * 2));
    flex-grow: 1;
    flex-shrink: 0;
    position: relative;

    display: flex;
    flex-direction: column;
}

.gui_tab-list_sIspJ {
    height: 2.75rem;
    width: 100%;
    display: flex;
    align-items: flex-end;
    flex-shrink: 0;
    gap: 0.25rem;
    padding: 0.25rem;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 0.80rem;

    /* Overrides for react-tabs styling */
    margin: 0 !important;
    border-bottom: 0 !important;

    color: var(--text-primary);
}

.gui_tab_QF0IR {
    height: calc((2.75rem - 0.5rem) * 0.9);
    margin-bottom: 0;

    border-radius: 1rem 1rem 0.5rem 0.5rem;
    border: 1px solid var(--ui-black-transparent);

    padding: 0.125rem 1.25rem 0;
    font-size: 0.75rem;

    background-color: var(--ui-tertiary);
    color: var(--ui-text-primary-transparent);

    display: flex;
    justify-content: center;
    align-items: center;

    -webkit-user-select: none;

       -moz-user-select: none;

        -ms-user-select: none;

            user-select: none;
    white-space: nowrap;
}

.gui_tab_QF0IR:hover {
  background-color: var(--ui-primary);
}

.gui_tab_QF0IR.gui_is-selected_UFsl5 {
    height: calc(2.75rem - 0.5rem);
    color: var(--looks-secondary);
    background-color: var(--ui-white);
}

.gui_tab_QF0IR img {
    width: 1.375rem;
    filter: grayscale(100%);
}

[dir="ltr"] .gui_tab_QF0IR img {
    margin-right: 0.125rem;
}

[dir="rtl"] .gui_tab_QF0IR img {
    margin-left: 0.125rem;
}

/* mirror blocks and sound tab icons */

[dir="rtl"] .gui_tab_QF0IR:nth-of-type(1) img {
    transform: scaleX(-1);
}

[dir="rtl"] .gui_tab_QF0IR:nth-of-type(3) img {
    transform: scaleX(-1);
}

.gui_tab_QF0IR.gui_is-selected_UFsl5 img {
    filter: none;
}

/* Tab style overrides from react-tabs */

.gui_tab_QF0IR.gui_is-selected_UFsl5:after {
    display: none;
}

.gui_tab_QF0IR.gui_is-selected_UFsl5:focus {
    outline: none;
    box-shadow: none;
    border-color: var(--ui-black-transparent);
}

.gui_tab_QF0IR.gui_is-selected_UFsl5:focus:after {
    display: none;
}

/* Body of the tabs */

.gui_tabs_af7tX {
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.gui_tab-panel_kc4gL {
    position: relative;
    flex-grow: 1;
    display: none;
}

.gui_tab-panel_kc4gL.gui_is-selected_UFsl5 {
    display: flex;
}

.gui_blocks-wrapper_ieUzD {
    flex-grow: 1;
    position: relative;
}

.gui_stage-and-target-wrapper_QjvJN {
    /*
        Makes rows for children:
          1) stage menu
          2) stage
          3) sprite/stage selectors
        Only reason we need this, is so .targetWrapper, which holds the selectors,
        goes to full vertical height of the window
    */
    display: flex;
    flex-direction: column;
    /* pad entire wrapper to the left and right; allow children to fill width */
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    /* this will only ever be as wide as the stage */
    flex-basis: 0;
}

.gui_target-wrapper_HJ42w {
    display: flex;
    flex-grow: 1;
    flex-basis: 0;

    padding-top: 0.5rem;
    min-height: 0; /* this makes it work in Firefox */

    /*
        For making the sprite-selector a scrollable pane
        @todo: Not working in Safari
    */
    /* TODO this also breaks the thermometer menu */
    /* overflow: hidden; */
}

.gui_extension-button-container_KAf8J {
    width: 3.75rem;
    height: 3.25rem;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 42;
    background: var(--looks-secondary);

    border: 1px solid var(--looks-secondary);
    box-sizing: content-box; /* To match scratch-block vertical toolbox borders */
}

.gui_extension-button-container_KAf8J:before {
    content: "";
    position: absolute;
    top: calc(calc(-1 * 15px) - 1px);
    left: -1px;
    background: linear-gradient(rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.15));
    height: 15px;
    width: calc(100% + 0.5px);
}

.gui_extension-button_V2B5K {
    background: none;
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.gui_extension-button-icon_pZL12 {
    width: 1.75rem;
    height: 1.75rem;
}

[dir="rtl"] .gui_extension-button-icon_pZL12 {
    transform: scaleX(-1);
}

.gui_extension-button_V2B5K > div {
    margin-top: 0;
}

/* Sprite Selection Watermark */

.gui_watermark_G_Q4G {
    position: absolute;
    top: 1.25rem;
    pointer-events: none;
}

[dir="ltr"] .gui_watermark_G_Q4G {
    right: 1.25rem;
}

[dir="rtl"] .gui_watermark_G_Q4G {
    left: 1.25rem;
}

/* Menu */

.gui_menu-bar-position_nzITJ {
    position: relative;
    z-index: 491;
}

/* Alerts */

.gui_alerts-container_kiiNN {
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 490;
    position: absolute;
    margin-top: 53px;
    pointer-events: none;
}

/*
    Make the (background) page not scrollable when modals are open
    This CSS class is automatically added to the body when react-modal is open
*/

.ReactModal__Body--open {
    overflow: hidden;
}

/* when in the browser's fullscreen mode, we need to put our own background to avoid just having black */

.gui_fullscreen-background_MULkR {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* overridden by JS; this will be used if the browser can't understand that color */
    background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/gui/gui.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;;IAEb;;;;KAIC;IACD,mBAAmB;IACnB,YAAY;;IAEZ;;;;KAIC;IACD,gBAAgB;AACpB;;AAEA;IACI;;;;;;;;;KASC;IACD,6DAA6D;IAC7D,YAAY;IACZ,cAAc;IACd,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,gBAAgB;;IAEhB,2DAA2D;IAC3D,gBAAgB;IAChB,kBAAkB;;IAElB,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;;IAE3B,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;;IAEhB,sCAAsC;IACtC,6CAA6C;;IAE7C,2BAA2B;IAC3B,kBAAkB;;IAElB,oCAAoC;IACpC,yCAAyC;;IAEzC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,yBAAyB;;OAEtB,sBAAsB;;QAErB,qBAAqB;;YAEjB,iBAAiB;IACzB,mBAAmB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sCAAsC;;AAEtC;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA,wCAAwC;;AAExC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;;;;;;;KAOC;IACD,aAAa;IACb,sBAAsB;IACtB,2EAA2E;IAC3E,oBAAoB;IACpB,qBAAqB;;IAErB,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;;IAEb,mBAAmB;IACnB,aAAa,EAAE,kCAAkC;;IAEjD;;;KAGC;IACD,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,kCAAkC;;IAElC,wCAAwC;IACxC,uBAAuB,EAAE,oDAAoD;AACjF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,iEAAiE;IACjE,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,SAAS;;AAET;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;;CAGC;;AAED;IACI,gBAAgB;AACpB;;AAEA,wGAAwG;;AAExG;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mFAAmF;IACnF,uBAAuB;AAC3B","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.page-wrapper {\n    height: 100%;\n}\n\n.body-wrapper {\n    height: calc(100% - 3rem);\n    background-color: var(--ui-primary);\n}\n\n.body-wrapper * {\n    box-sizing: border-box;\n}\n\n.flex-wrapper {\n    display: flex;\n\n    /*\n        Make 2 columns:\n        a) for the blocks + workspace panes, and\n        b) for combined stage menu + stage + sprite/stage selectors\n    */\n    flex-direction: row;\n    height: 100%;\n\n    /*\n        Stop scrollbar popping in and out from scratch-blocks border issue\n        https://github.com/LLK/scratch-gui/issues/318\n        TW: and also fix double horizontal scrollbar at some screen sizes in paint editor\n    */\n    overflow: hidden;\n}\n\n.editor-wrapper {\n    /*\n        This is carefully balanced--  the minimum width at which the GUI will be displayed is 1024px.\n        At that size, the stage pane is 408px wide, with $space of padding to each side.\n        However, we must also add the border width to the stage pane. All-in-all, the stage pane's final width is\n        408px + ($space + $stage-standard-border-width * 2) (one border & padding per left/right side).\n\n        @todo This is in place to prevent \"doubling up\" of horizontal scrollbars in narrow windows, but there are likely\n        much better ways to solve that (e.g. undo #2124, remove this flex-basis entirely). However, they run their own\n        risks of breaking things, so let's just leave this as-is for the time being.\n    */\n    flex-basis: calc(1024px - 408px - ((0.5rem + 0.0625rem) * 2));\n    flex-grow: 1;\n    flex-shrink: 0;\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n}\n\n.tab-list {\n    height: 2.75rem;\n    width: 100%;\n    display: flex;\n    align-items: flex-end;\n    flex-shrink: 0;\n    gap: 0.25rem;\n    padding: 0.25rem;\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-weight: 500;\n    font-size: 0.80rem;\n\n    /* Overrides for react-tabs styling */\n    margin: 0 !important;\n    border-bottom: 0 !important;\n\n    color: var(--text-primary);\n}\n\n.tab {\n    height: calc((2.75rem - 0.5rem) * 0.9);\n    margin-bottom: 0;\n\n    border-radius: 1rem 1rem 0.5rem 0.5rem;\n    border: 1px solid var(--ui-black-transparent);\n\n    padding: 0.125rem 1.25rem 0;\n    font-size: 0.75rem;\n\n    background-color: var(--ui-tertiary);\n    color: var(--ui-text-primary-transparent);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    -webkit-user-select: none;\n\n       -moz-user-select: none;\n\n        -ms-user-select: none;\n\n            user-select: none;\n    white-space: nowrap;\n}\n\n.tab:hover {\n  background-color: var(--ui-primary);\n}\n\n.tab.is-selected {\n    height: calc(2.75rem - 0.5rem);\n    color: var(--looks-secondary);\n    background-color: var(--ui-white);\n}\n\n.tab img {\n    width: 1.375rem;\n    filter: grayscale(100%);\n}\n\n[dir=\"ltr\"] .tab img {\n    margin-right: 0.125rem;\n}\n\n[dir=\"rtl\"] .tab img {\n    margin-left: 0.125rem;\n}\n\n/* mirror blocks and sound tab icons */\n\n[dir=\"rtl\"] .tab:nth-of-type(1) img {\n    transform: scaleX(-1);\n}\n\n[dir=\"rtl\"] .tab:nth-of-type(3) img {\n    transform: scaleX(-1);\n}\n\n.tab.is-selected img {\n    filter: none;\n}\n\n/* Tab style overrides from react-tabs */\n\n.tab.is-selected:after {\n    display: none;\n}\n\n.tab.is-selected:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: var(--ui-black-transparent);\n}\n\n.tab.is-selected:focus:after {\n    display: none;\n}\n\n/* Body of the tabs */\n\n.tabs {\n    position: relative;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.tab-panel {\n    position: relative;\n    flex-grow: 1;\n    display: none;\n}\n\n.tab-panel.is-selected {\n    display: flex;\n}\n\n.blocks-wrapper {\n    flex-grow: 1;\n    position: relative;\n}\n\n.stage-and-target-wrapper {\n    /*\n        Makes rows for children:\n          1) stage menu\n          2) stage\n          3) sprite/stage selectors\n        Only reason we need this, is so .targetWrapper, which holds the selectors,\n        goes to full vertical height of the window\n    */\n    display: flex;\n    flex-direction: column;\n    /* pad entire wrapper to the left and right; allow children to fill width */\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n\n    /* this will only ever be as wide as the stage */\n    flex-basis: 0;\n}\n\n.target-wrapper {\n    display: flex;\n    flex-grow: 1;\n    flex-basis: 0;\n\n    padding-top: 0.5rem;\n    min-height: 0; /* this makes it work in Firefox */\n\n    /*\n        For making the sprite-selector a scrollable pane\n        @todo: Not working in Safari\n    */\n    /* TODO this also breaks the thermometer menu */\n    /* overflow: hidden; */\n}\n\n.extension-button-container {\n    width: 3.75rem;\n    height: 3.25rem;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 42;\n    background: var(--looks-secondary);\n\n    border: 1px solid var(--looks-secondary);\n    box-sizing: content-box; /* To match scratch-block vertical toolbox borders */\n}\n\n.extension-button-container:before {\n    content: \"\";\n    position: absolute;\n    top: calc(calc(-1 * 15px) - 1px);\n    left: -1px;\n    background: linear-gradient(rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.15));\n    height: 15px;\n    width: calc(100% + 0.5px);\n}\n\n.extension-button {\n    background: none;\n    border: none;\n    outline: none;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.extension-button-icon {\n    width: 1.75rem;\n    height: 1.75rem;\n}\n\n[dir=\"rtl\"] .extension-button-icon {\n    transform: scaleX(-1);\n}\n\n.extension-button > div {\n    margin-top: 0;\n}\n\n/* Sprite Selection Watermark */\n\n.watermark {\n    position: absolute;\n    top: 1.25rem;\n    pointer-events: none;\n}\n\n[dir=\"ltr\"] .watermark {\n    right: 1.25rem;\n}\n\n[dir=\"rtl\"] .watermark {\n    left: 1.25rem;\n}\n\n/* Menu */\n\n.menu-bar-position {\n    position: relative;\n    z-index: 491;\n}\n\n/* Alerts */\n\n.alerts-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    z-index: 490;\n    position: absolute;\n    margin-top: 53px;\n    pointer-events: none;\n}\n\n/*\n    Make the (background) page not scrollable when modals are open\n    This CSS class is automatically added to the body when react-modal is open\n*/\n\n:global(.ReactModal__Body--open) {\n    overflow: hidden;\n}\n\n/* when in the browser's fullscreen mode, we need to put our own background to avoid just having black */\n\n.fullscreen-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    /* overridden by JS; this will be used if the browser can't understand that color */\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `gui_page-wrapper_XhImG`;
export { _1 as "page-wrapper" };
export var pageWrapper = `gui_page-wrapper_XhImG`;
var _2 = `gui_body-wrapper_G5GJN`;
export { _2 as "body-wrapper" };
export var bodyWrapper = `gui_body-wrapper_G5GJN`;
var _3 = `gui_flex-wrapper_zZPgR`;
export { _3 as "flex-wrapper" };
export var flexWrapper = `gui_flex-wrapper_zZPgR`;
var _4 = `gui_editor-wrapper_w4WEQ`;
export { _4 as "editor-wrapper" };
export var editorWrapper = `gui_editor-wrapper_w4WEQ`;
var _5 = `gui_tab-list_sIspJ`;
export { _5 as "tab-list" };
export var tabList = `gui_tab-list_sIspJ`;
export var tab = `gui_tab_QF0IR`;
var _6 = `gui_is-selected_UFsl5`;
export { _6 as "is-selected" };
export var isSelected = `gui_is-selected_UFsl5`;
export var tabs = `gui_tabs_af7tX`;
var _7 = `gui_tab-panel_kc4gL`;
export { _7 as "tab-panel" };
export var tabPanel = `gui_tab-panel_kc4gL`;
var _8 = `gui_blocks-wrapper_ieUzD`;
export { _8 as "blocks-wrapper" };
export var blocksWrapper = `gui_blocks-wrapper_ieUzD`;
var _9 = `gui_stage-and-target-wrapper_QjvJN`;
export { _9 as "stage-and-target-wrapper" };
export var stageAndTargetWrapper = `gui_stage-and-target-wrapper_QjvJN`;
var _a = `gui_target-wrapper_HJ42w`;
export { _a as "target-wrapper" };
export var targetWrapper = `gui_target-wrapper_HJ42w`;
var _b = `gui_extension-button-container_KAf8J`;
export { _b as "extension-button-container" };
export var extensionButtonContainer = `gui_extension-button-container_KAf8J`;
var _c = `gui_extension-button_V2B5K`;
export { _c as "extension-button" };
export var extensionButton = `gui_extension-button_V2B5K`;
var _d = `gui_extension-button-icon_pZL12`;
export { _d as "extension-button-icon" };
export var extensionButtonIcon = `gui_extension-button-icon_pZL12`;
export var watermark = `gui_watermark_G_Q4G`;
var _e = `gui_menu-bar-position_nzITJ`;
export { _e as "menu-bar-position" };
export var menuBarPosition = `gui_menu-bar-position_nzITJ`;
var _f = `gui_alerts-container_kiiNN`;
export { _f as "alerts-container" };
export var alertsContainer = `gui_alerts-container_kiiNN`;
var _10 = `gui_fullscreen-background_MULkR`;
export { _10 as "fullscreen-background" };
export var fullscreenBackground = `gui_fullscreen-background_MULkR`;
export default ___CSS_LOADER_EXPORT___;
